export default async (context, inject) => {
  inject("params", {
    /**
     * getパラメータ保存用boCode
     */
    get boCode() {
      return context.store.state.params.boCode;
    },
    set boCode(value) {
      context.store.commit("params/boCode", value);
    },
    /**
     * getパラメータ保存用companyCd
     */
    get companyCd() {
      return context.store.state.params.companyCd;
    },
    set companyCd(value) {
      context.store.commit("params/companyCd", value);
    }
  });
};
